module.exports = __webpack_public_path__ + "img/img1.ec420bcd.jpeg";